<main class="history-container">
  <!-- Header Section - Style Befret épuré comme order-summary -->
  <div class="history-header">
    <div class="container py-4">
      <div class="row align-items-center">
        <div class="col-lg-12">
          <h1 class="page-title">
            <i class="fas fa-list me-3"></i>
            {{ "PARCEL_LIST.TITLE" | productionTranslate }}
          </h1>
          <p class="page-subtitle">
            {{ "PARCEL_LIST.SUBTITLE" | productionTranslate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <section class="pt40 pb40">
    <div class="container">

      <!-- Statistics Cards — clickable to filter -->
      <div class="row mb-4" *ngIf="!isLoading">
        <div class="col-6 col-md-3 mb-3">
          <mat-card class="stat-card stat-card-total" [class.active]="activeStatCard === 'all'" (click)="filterByStatCard('all')">
            <mat-card-content>
              <div class="stat-icon">
                <mat-icon>inventory_2</mat-icon>
              </div>
              <div class="stat-info">
                <h3>{{totalShipments}}</h3>
                <p>{{ "PARCEL_LIST.STATS.TOTAL" | productionTranslate }}</p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col-6 col-md-3 mb-3">
          <mat-card class="stat-card stat-card-transit" [class.active]="activeStatCard === 'in_transit'" (click)="filterByStatCard('in_transit')">
            <mat-card-content>
              <div class="stat-icon">
                <mat-icon>local_shipping</mat-icon>
              </div>
              <div class="stat-info">
                <h3>{{shipmentsInTransit}}</h3>
                <p>{{ "PARCEL_LIST.STATS.IN_TRANSIT" | productionTranslate }}</p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col-6 col-md-3 mb-3">
          <mat-card class="stat-card stat-card-arrived" [class.active]="activeStatCard === 'congo_distribution'" (click)="filterByStatCard('congo_distribution')">
            <mat-card-content>
              <div class="stat-icon">
                <mat-icon>flight_land</mat-icon>
              </div>
              <div class="stat-info">
                <h3>{{shipmentsArrivedCongo}}</h3>
                <p>{{ "PARCEL_LIST.STATS.ARRIVED_CONGO" | productionTranslate }}</p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col-6 col-md-3 mb-3">
          <mat-card class="stat-card stat-card-delivered" [class.active]="activeStatCard === 'delivered'" (click)="filterByStatCard('delivered')">
            <mat-card-content>
              <div class="stat-icon">
                <mat-icon>check_circle</mat-icon>
              </div>
              <div class="stat-info">
                <h3>{{shipmentsDelivered}}</h3>
                <p>{{ "PARCEL_LIST.STATS.DELIVERED" | productionTranslate }}</p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- Incident card — only visible if there are incidents -->
        <div class="col-6 col-md-3 mb-3" *ngIf="shipmentsIncident > 0">
          <mat-card class="stat-card stat-card-incident" [class.active]="activeStatCard === 'incident'" (click)="filterByStatCard('incident')">
            <mat-card-content>
              <div class="stat-icon">
                <mat-icon>warning</mat-icon>
              </div>
              <div class="stat-info">
                <h3>{{shipmentsIncident}}</h3>
                <p>{{ "PARCEL_LIST.STATS.INCIDENTS" | productionTranslate }}</p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <!-- Main Card -->
      <mat-card class="shipments-card">

        <!-- Toolbar -->
        <mat-card-header class="shipments-header">
          <mat-card-title>
            <mat-icon>list_alt</mat-icon>
            {{ "PARCEL_LIST.TITLE" | productionTranslate }}
          </mat-card-title>

          <div class="header-actions">
            <button mat-raised-button color="primary" (click)="refreshData()" class="befret-button">
              <mat-icon>refresh</mat-icon>
              {{ "PARCEL_LIST.ACTIONS.REFRESH" | productionTranslate }}
            </button>

            <button mat-raised-button (click)="exportAll()" class="befret-button-outline">
              <mat-icon>file_download</mat-icon>
              {{ "PARCEL_LIST.ACTIONS.EXPORT" | productionTranslate }}
            </button>
          </div>
        </mat-card-header>

        <mat-card-content>

          <!-- Filters Section -->
          <div class="filters-section">

            <!-- Mobile: Search + action buttons row -->
            <div class="mobile-search-row" *ngIf="isMobile">
              <div class="mobile-search-input">
                <i class="fas fa-search mobile-search-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  (keyup)="applyFilter($event)"
                  placeholder="{{ 'PARCEL_LIST.FILTERS.SEARCH_PLACEHOLDER' | productionTranslate }}">
              </div>
              <button class="btn mobile-filter-toggle"
                      [class.active]="showMobileFilters"
                      (click)="toggleMobileFilters()">
                <mat-icon>tune</mat-icon>
              </button>
              <button class="btn mobile-trash-btn"
                      [class.btn-danger]="showArchived"
                      (click)="toggleShowArchived()">
                <mat-icon>{{showArchived ? 'arrow_back' : 'delete_outline'}}</mat-icon>
                <span *ngIf="!showArchived && shipmentsArchived > 0" class="badge bg-danger">
                  {{shipmentsArchived}}
                </span>
              </button>
            </div>

            <!-- Mobile: Collapsible filters -->
            <div class="mobile-filters-panel" *ngIf="isMobile && showMobileFilters">
              <div class="mobile-filter-grid">
                <select class="form-select mobile-select"
                        [(ngModel)]="filterStatus"
                        (change)="onFilterChange()">
                  <option *ngFor="let option of statusOptions" [value]="option.value">
                    {{option.labelKey | productionTranslate}}
                  </option>
                </select>
                <select class="form-select mobile-select"
                        [(ngModel)]="filterCity"
                        (change)="onFilterChange()">
                  <option *ngFor="let option of cityOptions" [value]="option.value">
                    {{option.labelKey | productionTranslate}}
                  </option>
                </select>
                <select class="form-select mobile-select"
                        [(ngModel)]="filterType"
                        (change)="onFilterChange()">
                  <option *ngFor="let option of typeOptions" [value]="option.value">
                    {{option.labelKey | productionTranslate}}
                  </option>
                </select>
                <select class="form-select mobile-select"
                        [(ngModel)]="filterCountry"
                        (change)="onFilterChange()">
                  <option *ngFor="let option of countryOptions" [value]="option.value">
                    {{option.labelKey | productionTranslate}}
                  </option>
                </select>
              </div>
              <button class="btn btn-sm mobile-clear-btn" (click)="clearFilters()">
                <i class="fas fa-times me-1"></i>
                {{ "PARCEL_LIST.FILTERS.RESET" | productionTranslate }}
              </button>
            </div>

            <!-- Desktop: Full filter row -->
            <div class="row g-3" *ngIf="!isMobile">

              <!-- Search Input -->
              <div class="col-md-2">
                <div class="filter-field">
                  <label class="filter-label">{{ "PARCEL_LIST.FILTERS.SEARCH" | productionTranslate }}</label>
                  <div class="input-with-icon">
                    <i class="fas fa-search input-icon"></i>
                    <input
                      type="text"
                      class="form-control"
                      (keyup)="applyFilter($event)"
                      placeholder="{{ 'PARCEL_LIST.FILTERS.SEARCH_PLACEHOLDER' | productionTranslate }}">
                  </div>
                </div>
              </div>

              <!-- Status Select -->
              <div class="col-md-2">
                <div class="filter-field">
                  <label class="filter-label">{{ "PARCEL_LIST.FILTERS.STATUS" | productionTranslate }}</label>
                  <div class="input-with-icon">
                    <i class="fas fa-filter input-icon"></i>
                    <select
                      class="form-select"
                      [(ngModel)]="filterStatus"
                      (change)="onFilterChange()">
                      <option *ngFor="let option of statusOptions" [value]="option.value">
                        {{option.labelKey | productionTranslate}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- City Select -->
              <div class="col-md-2">
                <div class="filter-field">
                  <label class="filter-label">{{ "PARCEL_LIST.FILTERS.CITY" | productionTranslate }}</label>
                  <div class="input-with-icon">
                    <i class="fas fa-map-marker-alt input-icon"></i>
                    <select
                      class="form-select"
                      [(ngModel)]="filterCity"
                      (change)="onFilterChange()">
                      <option *ngFor="let option of cityOptions" [value]="option.value">
                        {{option.labelKey | productionTranslate}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Type Select -->
              <div class="col-md-2">
                <div class="filter-field">
                  <label class="filter-label">{{ "PARCEL_LIST.FILTERS.TYPE" | productionTranslate }}</label>
                  <div class="input-with-icon">
                    <i class="fas fa-tag input-icon"></i>
                    <select
                      class="form-select"
                      [(ngModel)]="filterType"
                      (change)="onFilterChange()">
                      <option *ngFor="let option of typeOptions" [value]="option.value">
                        {{option.labelKey | productionTranslate}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Country Select -->
              <div class="col-md-2">
                <div class="filter-field">
                  <label class="filter-label">{{ "PARCEL_LIST.FILTERS.COUNTRY" | productionTranslate }}</label>
                  <div class="input-with-icon">
                    <i class="fas fa-globe input-icon"></i>
                    <select
                      class="form-select"
                      [(ngModel)]="filterCountry"
                      (change)="onFilterChange()">
                      <option *ngFor="let option of countryOptions" [value]="option.value">
                        {{option.labelKey | productionTranslate}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Reset Button -->
              <div class="col-md-1 d-flex align-items-end">
                <button class="btn btn-outline-secondary w-100 clear-filters-btn" (click)="clearFilters()">
                  <i class="fas fa-times me-2"></i>
                  {{ "PARCEL_LIST.FILTERS.RESET" | productionTranslate }}
                </button>
              </div>

              <!-- Corbeille Toggle -->
              <div class="col-md-1 d-flex align-items-end">
                <button
                  class="btn w-100"
                  [class.btn-outline-secondary]="!showArchived"
                  [class.btn-danger]="showArchived"
                  (click)="toggleShowArchived()"
                  [matTooltip]="showArchived ? 'Retour aux envois actifs' : 'Corbeille'">
                  <mat-icon style="font-size: 18px; height: 18px; width: 18px;">
                    {{showArchived ? 'arrow_back' : 'delete_outline'}}
                  </mat-icon>
                  <span *ngIf="!showArchived && shipmentsArchived > 0" class="badge bg-danger ms-1" style="font-size: 10px;">
                    {{shipmentsArchived}}
                  </span>
                </button>
              </div>

            </div>
          </div>

          <!-- Corbeille Banner -->
          <div class="trash-banner" *ngIf="showArchived">
            <div class="d-flex align-items-center gap-2">
              <mat-icon>delete_outline</mat-icon>
              <strong>{{ "PARCEL_LIST.TRASH.TITLE" | productionTranslate }}</strong>
              <span>&mdash; {{ "PARCEL_LIST.TRASH.COUNT" | productionTranslate:{ count: shipmentsArchived } }}</span>
            </div>
            <button class="btn btn-sm btn-outline-light" (click)="toggleShowArchived()">
              <mat-icon style="font-size: 16px; height: 16px; width: 16px;">arrow_back</mat-icon>
              {{ "PARCEL_LIST.TRASH.BACK_TO_ACTIVE" | productionTranslate }}
            </button>
          </div>

          <!-- Bulk Actions (Manager Only) -->
          <div class="bulk-actions" *ngIf="selection.hasValue()">
            <div class="selection-info">
              <mat-icon>check_circle</mat-icon>
              {{selection.selected.length}} {{ "PARCEL_LIST.SELECTED" | productionTranslate }}
            </div>
            <div class="d-flex gap-2">
              <button mat-raised-button color="warn" (click)="bulkDelete()" class="befret-button">
                <mat-icon>delete</mat-icon>
                {{ "PARCEL_LIST.BULK_DELETE" | productionTranslate }}
              </button>
              <button mat-raised-button (click)="bulkExport()" class="befret-button-outline">
                <mat-icon>file_download</mat-icon>
                {{ "PARCEL_LIST.BULK_EXPORT" | productionTranslate }}
              </button>
            </div>
          </div>

          <!-- Loading Spinner -->
          <div class="loading-container" *ngIf="isLoading">
            <mat-spinner diameter="50"></mat-spinner>
            <p>{{ "PARCEL_LIST.LOADING" | productionTranslate }}</p>
          </div>

          <!-- Data Table (hidden on mobile, stays in DOM for sort/filter) -->
          <div class="table-container" *ngIf="!isLoading" [hidden]="isMobile">
            <table mat-table [dataSource]="dataSource" matSort class="shipments-table mat-elevation-z2">

              <!-- Select Column (Manager Only) -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? toggleAllRows() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- Icon Column -->
              <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                  <mat-icon *ngIf="row.type === 'mail'" class="type-icon envelope-icon">mail</mat-icon>
                  <mat-icon *ngIf="row.type === 'package'" class="type-icon package-icon">inventory_2</mat-icon>
                  <mat-icon *ngIf="row.type === 'heavy_parcel'" class="type-icon package-icon">inventory_2</mat-icon>
                </td>
              </ng-container>

              <!-- Tracking ID Column -->
              <ng-container matColumnDef="trackingID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "PARCEL_LIST.COLUMNS.TRACKING_ID" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" class="tracking-cell" data-label="Tracking">
                  <strong>{{row.trackingID}}</strong>
                  <br>
                  <span class="type-badge">{{getTypeLabel(row.type)}}</span>
                </td>
              </ng-container>

              <!-- Sender Column -->
              <ng-container matColumnDef="sender_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "PARCEL_LIST.COLUMNS.SENDER" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" data-label="Exp.">
                  <div class="sender-cell">
                    <mat-icon class="sender-icon">person_outline</mat-icon>
                    <span>{{row.sender_name}}</span>
                  </div>
                </td>
              </ng-container>

              <!-- Receiver Column -->
              <ng-container matColumnDef="receiver_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "PARCEL_LIST.COLUMNS.RECEIVER" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" data-label="Dest.">
                  <div class="receiver-cell">
                    <mat-icon class="receiver-icon">person</mat-icon>
                    <span>{{row.receiver_name}}</span>
                  </div>
                </td>
              </ng-container>

              <!-- City Column -->
              <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "PARCEL_LIST.COLUMNS.CITY" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" data-label="Ville">
                  <mat-chip class="city-chip">
                    <mat-icon>location_on</mat-icon>
                    {{row.city}}
                  </mat-chip>
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "PARCEL_LIST.COLUMNS.STATUS" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" data-label="Statut">
                  <mat-chip *ngIf="row.archived" class="status-chip archived-chip">
                    {{ "PARCEL_LIST.STATUS_DELETED" | productionTranslate }}
                  </mat-chip>
                  <mat-chip *ngIf="!row.archived" [ngClass]="'status-chip-' + row.status" class="status-chip">
                    {{getStatusLabel(row.status)}}
                  </mat-chip>
                </td>
              </ng-container>

              <!-- Cost Column -->
              <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
                  {{ "PARCEL_LIST.COLUMNS.COST" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" class="text-end cost-cell" data-label="Co&#xFB;t">
                  <strong>{{row.cost | number:'1.2-2'}} &euro;</strong>
                </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
                  {{ "PARCEL_LIST.COLUMNS.WEIGHT" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" class="text-end" data-label="Poids">
                  <span *ngIf="row.type === 'mail'">0-1 kg</span>
                  <span *ngIf="row.type === 'package' || row.type === 'heavy_parcel'">{{row.weight}} kg</span>
                </td>
              </ng-container>

              <!-- Date Column -->
              <ng-container matColumnDef="create_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "PARCEL_LIST.COLUMNS.DATE" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" data-label="Date">
                  <span class="date-cell">{{row.create_date | date:'dd/MM/yyyy'}}</span>
                  <br>
                  <span class="time-cell">{{row.create_date | date:'HH:mm'}}</span>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-end">
                  {{ "PARCEL_LIST.COLUMNS.ACTIONS" | productionTranslate }}
                </th>
                <td mat-cell *matCellDef="let row" class="text-end actions-cell" data-label="">
                  <button mat-icon-button [matMenuTriggerFor]="menu" class="action-button" (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="viewDetails(row.trackingID)">
                      <mat-icon>visibility</mat-icon>
                      <span>{{ "PARCEL_LIST.ACTIONS.VIEW_DETAILS" | productionTranslate }}</span>
                    </button>
                    <button mat-menu-item (click)="viewDetails(row.trackingID)">
                      <mat-icon>track_changes</mat-icon>
                      <span>{{ "PARCEL_LIST.ACTIONS.TRACK" | productionTranslate }}</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item>
                      <mat-icon>print</mat-icon>
                      <span>{{ "PARCEL_LIST.ACTIONS.PRINT" | productionTranslate }}</span>
                    </button>
                    <button mat-menu-item>
                      <mat-icon>file_download</mat-icon>
                      <span>{{ "PARCEL_LIST.ACTIONS.DOWNLOAD" | productionTranslate }}</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                  class="shipment-row"
                  [class.archived-row]="row.archived"
                  (click)="onRowClick($event, row.trackingID)">
              </tr>

              <!-- No Data Row -->
              <tr class="mat-row no-data-row" *matNoDataRow>
                <td class="mat-cell" colspan="11">
                  <div class="no-data-container">
                    <mat-icon class="no-data-icon">inventory_2</mat-icon>
                    <h3>{{ "PARCEL_LIST.NO_SHIPMENTS" | productionTranslate }}</h3>
                    <p>{{ "PARCEL_LIST.NO_RESULTS" | productionTranslate }}</p>
                    <button mat-raised-button color="primary" class="befret-button">
                      {{ "PARCEL_LIST.CREATE_SHIPMENT" | productionTranslate }}
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <!-- Mobile Card View -->
          <div class="mobile-cards" *ngIf="!isLoading && isMobile">
            <div *ngFor="let row of paginatedData"
                 class="shipment-card"
                 [class.archived-card]="row.archived"
                 (click)="viewDetails(row.trackingID)">

              <div class="card-header-row">
                <div class="card-header-left">
                  <strong class="card-tracking-id">{{row.trackingID}}</strong>
                  <span class="type-badge">{{getTypeLabel(row.type)}}</span>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="mobileMenu" class="card-action-btn" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #mobileMenu="matMenu">
                  <button mat-menu-item (click)="viewDetails(row.trackingID)">
                    <mat-icon>visibility</mat-icon>
                    <span>{{ "PARCEL_LIST.ACTIONS.VIEW_DETAILS" | productionTranslate }}</span>
                  </button>
                  <button mat-menu-item (click)="viewDetails(row.trackingID)">
                    <mat-icon>track_changes</mat-icon>
                    <span>{{ "PARCEL_LIST.ACTIONS.TRACK" | productionTranslate }}</span>
                  </button>
                </mat-menu>
              </div>

              <div class="card-info-grid">
                <div class="card-row">
                  <span class="card-label">Exp.</span>
                  <span class="card-value">{{row.sender_name}}</span>
                </div>
                <div class="card-row">
                  <span class="card-label">Dest.</span>
                  <span class="card-value">{{row.receiver_name}}</span>
                </div>
                <div class="card-row">
                  <span class="card-label">Ville</span>
                  <span class="card-value">{{row.city}}</span>
                </div>
                <div class="card-row">
                  <span class="card-label">{{ "PARCEL_LIST.COLUMNS.STATUS" | productionTranslate }}</span>
                  <span class="card-value">
                    <mat-chip *ngIf="row.archived" class="status-chip archived-chip mobile-chip">{{ "PARCEL_LIST.STATUS_DELETED" | productionTranslate }}</mat-chip>
                    <mat-chip *ngIf="!row.archived" [ngClass]="'status-chip-' + row.status" class="status-chip mobile-chip">
                      {{getStatusLabel(row.status)}}
                    </mat-chip>
                  </span>
                </div>
                <div class="card-row">
                  <span class="card-label">{{ "PARCEL_LIST.COLUMNS.COST" | productionTranslate }}</span>
                  <span class="card-value card-cost">{{row.cost | number:'1.2-2'}} &euro;</span>
                </div>
                <div class="card-row">
                  <span class="card-label">Poids</span>
                  <span class="card-value">
                    <span *ngIf="row.type === 'mail'">0-1 kg</span>
                    <span *ngIf="row.type !== 'mail'">{{row.weight}} kg</span>
                  </span>
                </div>
                <div class="card-row">
                  <span class="card-label">Date</span>
                  <span class="card-value">{{row.create_date | date:'dd/MM/yy HH:mm'}}</span>
                </div>
              </div>

            </div>

            <div *ngIf="paginatedData.length === 0" class="no-data-container">
              <mat-icon class="no-data-icon">inventory_2</mat-icon>
              <h3>{{ "PARCEL_LIST.NO_SHIPMENTS" | productionTranslate }}</h3>
              <p>{{ "PARCEL_LIST.NO_RESULTS" | productionTranslate }}</p>
            </div>
          </div>

          <!-- Desktop Paginator -->
          <mat-paginator
            [pageSizeOptions]="[10, 25, 50, 100]"
            [pageSize]="25"
            [showFirstLastButtons]="true"
            [class.hidden-paginator]="isMobile"
            class="shipments-paginator">
          </mat-paginator>

          <!-- Mobile Paginator -->
          <div class="mobile-paginator" *ngIf="isMobile && totalPages > 1">
            <button class="mobile-page-btn"
                    [disabled]="!hasPrevPage"
                    (click)="prevPage()">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="mobile-page-indicator">{{currentPage}} / {{totalPages}}</span>
            <button class="mobile-page-btn"
                    [disabled]="!hasNextPage"
                    (click)="nextPage()">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>

        </mat-card-content>
      </mat-card>

    </div>
  </section>
</main>
